/** Persistent banner shown while a super-admin is impersonating a partner
 *  ("open partner console"). Makes it impossible to forget you're viewing as
 *  someone else, and offers a one-click exit back to the platform console. */
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { stopImpersonation, useImpersonation } from "@/lib/impersonation";

export function ImpersonationBanner() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const current = useImpersonation((s) => s.current);
  if (!current) return null;
  return (
    <div
      role="status"
      data-testid="impersonation-banner"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-center gap-3 bg-amber-400 px-4 py-2 text-sm font-medium text-black"
    >
      <span>{t("impersonation.banner", { name: current.name })}</span>
      <button
        type="button"
        data-testid="impersonation-exit"
        className="rounded bg-black/20 px-2 py-0.5 hover:bg-black/30"
        onClick={() => {
          stopImpersonation();
          navigate("/platform/partners");
        }}
      >
        {t("impersonation.exit")}
      </button>
    </div>
  );
}
